// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InputAmount_wrap__1AvlU","input":"InputAmount_input__1uZju","label":"InputAmount_label__1q7nn","right":"InputAmount_right__1zFsB"};